import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Canvas3DComponent } from '../../canvas3D';
import { ToastComponent } from '../../core';
import { SidebarComponent } from '../../sidebar';
import { NavbarComponent } from '../navbar';


/**
 * Main container component of application.
 */
@Component({
	selector: 'container-template',
	templateUrl: './container-template.component.html',
	imports: [
		ToastComponent,
		NavbarComponent,
		SidebarComponent,
		Canvas3DComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ContainerTemplateComponent { }
